import * as React from 'react';
import {Tab} from 'semantic-ui-react';
// view container
import ViewContainer from "../ViewContainer";
// Tabs
import {connect} from 'react-redux';
import {translate} from 'react-i18next';

import AccessTab from "./AccessTab/AccessTab";
import {RouteComponentProps} from 'react-router';

import {MenuDto} from "../../services/Client";
import WorkflowTab from './WorkflowTab/WorkflowTab';
import SpecConfiguration from './SpecConfigTab/SpecConfiguration';
import ErrorBoundary from '../../utils/ErrorBoundary';
import ConfigurationMaintenance from './ConfigMaintenanceTab/ConfigurationMaintenance';
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import GeneralActions from "../../redux/actions/GeneralActions";
import AdminViewActions from "../../redux/actions/AdminViewActions";
import TextFlag from "./FlagTab/TextFlag";
import NotesAndNews from "./NotesAndNewsTab/NotesAndNews";
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";
import {
    selectBaseLinks,
    selectClient,
} from "../../redux/selectors";
import {compose, Dispatch} from "redux";
import HATEOASClient from "../../services/HATEOASClient";
import CategorySort from './CategorySortTab/CategorySort';
import {IReduxState} from '../../redux/IReduxState';
import LanguageTable from "./LanguageTab/LanguageTable";
import Faq from "./FaqTab/Faq";

interface IMapStateToProps {
    client: HATEOASClient;
    baseLinks?: MenuDto;
}

interface IMapDispatchToProps {
    addTranslationLocation: () => void;
    receiveAdminareaLinks: (adminAreaLinks: MenuDto) => void;
}

interface IOwnProps {
}

interface IAdminViewProps extends IOwnProps, IMapStateToProps, IMapDispatchToProps, ITranslatedComponent, RouteComponentProps<any> {
}

interface IAdminViewState {
    displayItems?: number;
    activeIndex?: number;
}

class AdminView extends React.Component<IAdminViewProps, IAdminViewState> {
    list?: string;
    state: IAdminViewState = {
        activeIndex: 0,
        displayItems: 4
    };

    constructor(props: IAdminViewProps) {
        super(props);
    }

    componentDidMount() {
        this.props.addTranslationLocation();

        if (this.props.baseLinks) {
            this.requestAdminAreaLinks(this.props.baseLinks);
        }
    }

    componentWillReceiveProps(newProps: IAdminViewProps) {
        if (!this.props.baseLinks && newProps.baseLinks) {
            // the base links were received in the meantime
            this.requestAdminAreaLinks(newProps.baseLinks);
        }
    }

    requestAdminAreaLinks = (baseLinks: MenuDto) => {
        if (!this.props.client.GET_adminArea(baseLinks).canExecute()) {
            return;
        }

        // request the links to populate supported ui-controls
        this.props.client.GET_adminArea(baseLinks).execute()
            .then((adminAreaLinks: MenuDto) => {
                this.props.receiveAdminareaLinks(adminAreaLinks);
            })
            .catch((reason: any) => {
                window.scrollTo(0, 0);
                renderErrorToast({
                    message: "ERRORS:GET_ADMIN_AREA_LINKS",
                    details: reason,
                    timestamp: Date.now()
                });
            });
    }

    render() {
        const panes = [
            {
                menuItem: {content: this.props.t("ACCESS_TAB"), icon: 'group', key: 'access'},
                render: () => <Tab.Pane key='access'><AccessTab {...this.props} /></Tab.Pane>
            },
            {
                menuItem: {content: this.props.t("WORKFLOW_TAB"), icon: 'angle double right', key: 'workflow'},
                render: () => <Tab.Pane key='workflow'><ErrorBoundary ><WorkflowTab {...this.props} /></ErrorBoundary></Tab.Pane>
            },
            {
                menuItem: {content: this.props.t("SPEC_CONFIG_TAB"), icon: 'list', key: 'spec'},
                render: () => <Tab.Pane key='spec'><ErrorBoundary ><SpecConfiguration displayItems={this.state.displayItems} /></ErrorBoundary></Tab.Pane>
            },
            {
                menuItem: {content: this.props.t("CONFIGURATION_MAINTENANCE_TAB"), icon: 'cogs', key: 'cfg'},
                render: () => <Tab.Pane key='cfg'><ErrorBoundary ><ConfigurationMaintenance /></ErrorBoundary></Tab.Pane>
            },
            {
                menuItem: {content: this.props.t("ADMIN_VIEW:FLAG_TAB"), icon: 'flag', key: 'flag'},
                render: () => <Tab.Pane key='flag'><ErrorBoundary ><TextFlag /></ErrorBoundary></Tab.Pane>
            },
            {
                menuItem: {content: this.props.t("ADMIN_VIEW:NOTES_AND_NEWS"), icon: 'newspaper', key: 'news'},
                render: () => <Tab.Pane key='news'><ErrorBoundary ><NotesAndNews /></ErrorBoundary></Tab.Pane>
            },
            {
                menuItem: {content: this.props.t("ADMIN_VIEW:FAQ"), icon: 'question circle', key: 'faq'},
                render: () => <Tab.Pane key='faq'><ErrorBoundary><Faq /></ErrorBoundary></Tab.Pane>
            },
            {
                menuItem: {content: this.props.t("ADMIN_VIEW:CATEGORY_SORT"), icon: 'sort numeric up', key: 'categSort'},
                render: () => <Tab.Pane key='categSort'><ErrorBoundary><CategorySort /></ErrorBoundary></Tab.Pane>
            },
            {
                menuItem: {content: this.props.t("ADMIN_VIEW:LANGUAGES"), icon: 'comment', key: 'languages'},
                render: () => <Tab.Pane key='languages'><ErrorBoundary><LanguageTable {...this.props}/></ErrorBoundary></Tab.Pane>
            }
        ];
        return (
            <ViewContainer
                viewContainerContentAlternateClass="viewContainerContent_height_90"
            >
                <div className='admin-view-content-container'>
                    <ErrorBoundary >
                        <Tab
                            menu={{fluid: true, vertical: false, tabular: true}}
                            panes={panes}
                            onTabChange={(e: any, d: any) => this.setState({activeIndex: d.activeIndex})}
                        />
                    </ErrorBoundary>
                </div>
            </ViewContainer>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    client: selectClient(state),
    baseLinks: selectBaseLinks(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    addTranslationLocation: () => dispatch(GeneralActions.AddTranslationLocation({pattern: "admin", substitutes: "ADMINISTRATION"})),
    receiveAdminareaLinks: (adminAreaLinks: MenuDto) => dispatch(AdminViewActions.ReceiveAdminareaLinks(adminAreaLinks)),

});

export default compose<React.ComponentType<IOwnProps>>(
    translate("ADMIN_VIEW"),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(AdminView);



// WEBPACK FOOTER //
// ./src/views/AdminView/AdminView.tsx